import { render, staticRenderFns } from "./Stap2.vue?vue&type=template&id=2cec8d5d&"
import script from "./Stap2.vue?vue&type=script&lang=js&"
export * from "./Stap2.vue?vue&type=script&lang=js&"
import style0 from "./Stap2.vue?vue&type=style&index=0&id=2cec8d5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports